/*
  Shared scroll-reveal for the Flex Knit story chapters (intro, anatomy,
  compare, day-on-the-trail). One IntersectionObserver-backed custom element
  so each section doesn't reinvent the same fade/rise-in.

  Usage: wrap any block in <cav-reveal> (optionally with a numeric
  data-delay-ms per child via [data-reveal]) and it gets an
  "is-visible" class once it scrolls into view. No-ops for visitors who
  prefer reduced motion — everything is visible immediately instead.
*/
(function () {
  'use strict';

  class CavReveal extends HTMLElement {
    connectedCallback() {
      const items = Array.from(this.querySelectorAll('[data-reveal]'));
      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const el = entry.target;
            const delay = Number(el.dataset.delayMs || 0);
            window.setTimeout(() => el.classList.add('is-visible'), delay);
            io.unobserve(el);
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );
      items.forEach((el) => io.observe(el));
    }
  }

  if (!customElements.get('cav-reveal')) customElements.define('cav-reveal', CavReveal);
})();
